import {Card} from './../types/Card';
import {Observable} from 'rxjs';
import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {DataSourceResponse, DataSourceService} from './DataSourceService';


@Injectable({ providedIn: 'root' })
export class CardService extends DataSourceService<Card> {

  constructor(private http: HttpClient) {
    super();
  }

  public loadData(
      filter: string = '',
      orderBy: string = '',
      orderDirection: string = 'ASC',
      pageNumber: number = 0,
      pageSize: number = 10
  ): Observable<DataSourceResponse<Card>> {
    return this.http.get<DataSourceResponse<Card>>('/cards/list', {
      params: new HttpParams()
        .set('filter', filter)
        .set('orderBy', orderBy)
        .set('sort', orderDirection.toUpperCase())
        .set('skip', pageNumber.toString())
        .set('take', pageSize.toString())
    });
  }

  public activateCard(requestId: Number): Observable<any> {
    return this.http.post<any>(`/cards/activate/${requestId}`, null);
  }

  public activateCardPan(formData: any): Observable<any> {
    return this.http.post<any>(`/cards/activate`, formData);
  }

  public suspendCard(requestId: Number): Observable<any> {
    return this.http.post<any>(`/cards/suspend/${requestId}`, null);
  }

  public sendReminder(formData: any): Observable<any> {
    return this.http.post<any>(`/cards/reminder`, formData);
  }

  public getCardPIN(requestId: Number): Observable<any> {
    return this.http.get<any>(`/cards/pin/${requestId}`);
  }

  public getCardInfo(requestId: Number): Observable<any> {
    return this.http.get<any>(`/cards/info/${requestId}`);
  }

  public getCardSafety(requestId: Number): Observable<any> {
    return this.http.get<any>(`/cards/safety/${requestId}`);
  }

  public topUpCard(formData: any): Observable<any> {
    return this.http.post<any>('/cards/create', formData);
  }

  public withdrawFromCard(formData: any): Observable<any> {
    return this.http.post<any>('/cards/withdraw', formData);
  }
}
